module.exports = __webpack_public_path__ + "static/media/portfolio1 (13).1f6d339c.jpeg";